import * as React from "react";
import TickIcon from "assets/svgIcons/CheckIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useEffect } from "react";
import { uuid } from "_helperFunctions/uuid";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { UserTableMainWrapper } from "pages/Admin/Users/UsersStyled";
import { Button, Tooltip } from "@mui/material";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import { useTranslation } from "react-i18next";
const initialSort = [
  {
    field: "username",
    dir: "asc",
  },
];
const initialDataState = {
  skip: 0,
  take: 15,
};

export default function EnhancedTable() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [rolesAndPrivsList, setRolesAndPrivsList] = React.useState([]);
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [selectedPrivOptions, setSelectedPrivOptions] = React.useState([]);
  const [newSelectData, setNewSelectData] = React.useState([]);
  const [newPrivilageData, setNewPrivilageData] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const {
    getVisageUsersAction,
    getRolesListAction,
    getPrivilegesListAction,
    getVisagaUsersListAction,
  } = useSelector((state) => state?.commonReducers) || [];
  const [sort, setSort] = React.useState(initialSort);
  const [page, setPage] = React.useState(() => {
    // Retrieve page from localStorage or use initialDataState
    const storedPage = localStorage.getItem("page");
    return storedPage ? JSON.parse(storedPage) : initialDataState;
  });
  const [pageSizeValue, setPageSizeValue] = React.useState(() => {
    // Retrieve pageSizeValue from localStorage or use default value
    return localStorage.getItem("pageSizeValue")
      ? localStorage.getItem("pageSizeValue")
      : 15;
  });

  const pageChange = (event) => {
    const targetEvent = event.targetEvent;
    const take = targetEvent.value === "All" ? 500 : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
      // Store pageSizeValue in localStorage
      localStorage.setItem("pageSizeValue", targetEvent.value);
    }

    const newPage = {
      ...event.page,
      take,
    };

    setPage(newPage);
    // Store page in localStorage
    localStorage.setItem("page", JSON.stringify(newPage));
  };

  React.useEffect(() => {
    dispatch(COMMON_SERVICES.getVisageUsersList());
    dispatch(COMMON_SERVICES.getRolesListServices());
    dispatch(COMMON_SERVICES.getPrivilegesListServices());
    dispatch(COMMON_SERVICES.getVisageUsersServices());
  }, []);

  React.useEffect(() => {
    let finalList = getRolesListAction.concat(getPrivilegesListAction);
    setRolesAndPrivsList(finalList);
  }, [getRolesListAction, getPrivilegesListAction]);

  useEffect(() => {
    if (getRolesListAction && getRolesListAction.length !== 0) {
      let tempData = getRolesListAction?.map((uRole) => {
        return {
          id: uuid(),
          value: uRole,
          label: uRole,
        };
      });

      setNewSelectData(tempData);
    }
  }, [getRolesListAction]);

  useEffect(() => {
    if (getPrivilegesListAction && getPrivilegesListAction.length !== 0) {
      let tempData = getPrivilegesListAction?.map((uRole) => {
        return {
          id: uuid(),
          value: uRole,
          label: uRole,
        };
      });

      setNewPrivilageData(tempData);
    }
  }, [getPrivilegesListAction]);

  useEffect(() => {
    setSelectedOptions([
      { id: uuid(), label: "All", value: "*" },
      ...newSelectData,
      { id: uuid(), label: "No Roles", value: "NoRoles" },
    ]);
  }, [newSelectData]);

  useEffect(() => {
    setSelectedPrivOptions([
      { id: uuid(), label: "All", value: "*" },
      ...newPrivilageData,
      { id: uuid(), label: "No Privileges", value: "NoPrivileges" },
    ]);
  }, [newPrivilageData]);

  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === "*")) {
      return `${placeholderButtonLabel}: All`;
    } else {
      return `${placeholderButtonLabel}: ${value.length} selected`;
    }
  }
  function getPrivDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === "*")) {
      return `${placeholderButtonLabel}: All`;
    } else {
      return `${placeholderButtonLabel}: ${value.length} selected`;
    }
  }

  function onSelectChange(value, event) {
    if (event.action === "select-option" && event.option.value === "*") {
      this.setState(this.options);
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      this.setState([]);
    } else if (event.action === "deselect-option") {
      this.setState(value.filter((o) => o.value !== "*"));
    } else if (value.length === this.options.length - 1) {
      this.setState(this.options);
    } else {
      this.setState(value);
    }
  }
  function onPrivSelectChange(value, event) {
    if (event.action === "select-option" && event.option.value === "*") {
      this.setState(this.options);
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      this.setState([]);
    } else if (event.action === "deselect-option") {
      this.setState(value.filter((o) => o.value !== "*"));
    } else if (value.length === this.options.length - 1) {
      this.setState(this.options);
    } else {
      this.setState(value);
    }
  }

  function getFilteredData() {
    // ****************** start Role *************************************

    let isAll = selectedOptions.some((el) => el.value === "*");
    let isNoRoles = selectedOptions.some((el) => el.value === "NoRoles");

    // ****************** End Roles *************************************
    // ****************** start Privilage *************************************

    let isPrivAll = selectedPrivOptions.some((el) => el.value === "*");
    let isNoPrivileges = selectedPrivOptions.some(
      (el) => el.value === "NoPrivileges"
    );

    // ****************** End Privilage *************************************

    let selectedRoles = selectedOptions
      .filter((el) => {
        if (el.value !== "*" || el.value !== "NoRoles") {
          return el;
        }
      })
      .map((el) => el.value);
    let selectedPrivs = selectedPrivOptions
      .filter((el) => {
        if (el.value !== "*" || el.value !== "NoPrivileges") {
          return el;
        }
      })
      .map((el) => el.value);

    let userWithRights = JSON.parse(JSON.stringify(getVisageUsersAction));

    let filteredUsers = userWithRights
      .filter((item) => {
        let isShowNonePrivs = item.privileges.length === 0 && isNoPrivileges;
        let isShowNoneRoles = item.roles.length === 0 && isNoRoles;

        let rolesFound = item.roles.some((r) => selectedRoles.includes(r));

        let privFound = item.privileges.some((r) => selectedPrivs.includes(r));

        if (
          ((selectedPrivs.length === 0 && !isNoPrivileges) ||
            privFound ||
            isShowNonePrivs) &&
          ((selectedRoles.length === 0 && !isNoRoles) ||
            rolesFound ||
            isShowNoneRoles)
        ) {
          return item.userid;
        }
      })
      .map((item) => item.userid);

    let tempUserValues = JSON.parse(JSON.stringify(getVisagaUsersListAction));
    let tempUserData = [];
    let tempFinalUserData = [];

    tempUserData = tempUserValues.filter((item) => {
      if (searchValue === "") {
        return item;
      } else if (
        item?.username.toLowerCase().includes(searchValue.toLowerCase())
      ) {
        return item?.username;
      }
    });

    tempFinalUserData = tempUserData.filter((u) => {
      if (filteredUsers.includes(Number(u.userid))) {
        return u;
      }
    });

    setRows(tempFinalUserData);
  }

  useEffect(() => {
    if (
      getVisagaUsersListAction &&
      getVisagaUsersListAction.length !== 0 &&
      getVisageUsersAction &&
      getVisageUsersAction.length !== 0
    ) {
      getFilteredData();
    }
  }, [
    getVisagaUsersListAction,
    getVisageUsersAction,
    selectedOptions,
    selectedPrivOptions,
    searchValue,
  ]);

  return (
    <>
      <div className="user-header">
        <Tooltip title={t("Filter_By_Username")}>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            className="search-input"
          />
        </Tooltip>
        <Tooltip title={t("Clear_Username_Filter")}>
          <Button
            variant="outlined"
            className="clear-button"
            onClick={() => setSearchValue("")}
          >
            {t("Clear")}
          </Button>
        </Tooltip>
        <Tooltip title={t("Filter_roles")}>
          <span>
            <ReactMultiSelectCheckboxes
              options={[
                { id: uuid(), label: "All", value: "*" },
                ...newSelectData,
                { id: uuid(), label: "No Roles", value: "NoRoles" },
              ]}
              placeholderButtonLabel="Roles"
              getDropdownButtonLabel={getDropdownButtonLabel}
              value={selectedOptions}
              onChange={onSelectChange}
              setState={setSelectedOptions}
              className="react-select-container"
              classNamePrefix="react-select"
              rightAligned={true}
            />
          </span>
        </Tooltip>
        <Tooltip title={t("Filter_Privileges")}>
          <span>
            <ReactMultiSelectCheckboxes
              options={[
                { id: uuid(), label: "All", value: "*" },
                ...newPrivilageData,
                { id: uuid(), label: "No privileges", value: "NoPrivileges" },
              ]}
              placeholderButtonLabel="Privileges"
              getDropdownButtonLabel={getPrivDropdownButtonLabel}
              value={selectedPrivOptions}
              onChange={onPrivSelectChange}
              setState={setSelectedPrivOptions}
              className="react-select-container"
              classNamePrefix="react-select"
              rightAligned={true}
            />
          </span>
        </Tooltip>
      </div>
      <UserTableMainWrapper>
        {rolesAndPrivsList && rolesAndPrivsList.length > 0 && rows ? (
          <>
            <div style={{ width: "100%" }}>
              <Grid
                style={{
                  height: "700px",
                }}
                data={orderBy(
                  rows.slice(page.skip, page.take + page.skip),
                  sort
                )}
                sortable={true}
                sort={sort}
                onSortChange={(e) => {
                  setSort(e.sort);
                }}
                skip={page.skip}
                take={page.take}
                total={rows.length}
                pageable={{
                  buttonCount: 4,
                  pageSizes: [
                    "All",
                    15,
                    20,
                    25,
                    30,
                    40,
                    50,
                    100,
                    150,
                    200,
                    250,
                  ],
                  pageSizeValue: pageSizeValue,
                }}
                onPageChange={pageChange}
              >
                <GridColumn
                  field="username"
                  width={250}
                  title={
                    <Tooltip title={t("Username")}>
                      <span>{t("Username")}</span>
                    </Tooltip>
                  }
                />
                {rolesAndPrivsList.map((col) => {
                  return (
                    <GridColumn
                      field={col}
                      title={
                        <Tooltip title={col}>
                          <span>{col}</span>
                        </Tooltip>
                      }
                      width={100}
                      cell={(props) => {
                        return (
                          <>
                            <td>
                              {props.field === "username" ? (
                                <>{props.dataItem.username}</>
                              ) : (
                                <>
                                  {props.dataItem[col] ? <TickIcon /> : <></>}
                                </>
                              )}
                            </td>
                          </>
                        );
                      }}
                    />
                  );
                })}
              </Grid>
            </div>
          </>
        ) : (
          <></>
        )}
      </UserTableMainWrapper>
    </>
  );
}
